export var AccountingLocationAnswerValue = /* @__PURE__ */ ((AccountingLocationAnswerValue2) => {
  AccountingLocationAnswerValue2["AccountingOffice"] = "AccountingOffice";
  AccountingLocationAnswerValue2["Own"] = "Own";
  return AccountingLocationAnswerValue2;
})(AccountingLocationAnswerValue || {});
